import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  Grid
} from '@material-ui/core';

import '../../assets/stylesheets/DashboardView.css';

import i18n from '../../i18n';
import { formatMoney } from '../../helpers/helpers';

class PlannedCost extends Component {
  renderDiscrepancy() {
    const { discrepancy } = this.props;
    return (
      <Grid container>
        <Grid item xs={12} className="ssenseWarning">
          <Divider className="costDivider" variant="middle" />
          <Typography align="center">{i18n.t('dashboard:discrepancyInBudgeting')}</Typography>
          <Typography align="center">
            {discrepancy.map(item =>
              `\nEmployeeId: ${item.studioEmployeeId}, PositionId: ${item.positionId}, Date: ${item.date}, AvailabilityType: ${item.availabilityType}`)}
          </Typography>
          <br />
        </Grid>
      </Grid>
    )
  }

  render() {
    const {
      fullTimeCost,
      freelancerCost,
      contractorCost,
      discrepancy,
    } = this.props;

    const totalCost = fullTimeCost + freelancerCost + contractorCost;

    return (
      <Card className="cardContainer">
        <CardHeader title="Total Planned Cost" />
        <CardContent className="plannedCostContent">
          <Typography
            className="plannedCostTitle"
            variant="body2"
            component="h1"
            align="center"
          >
            {formatMoney(totalCost)}
          </Typography>
          <Divider className="costDivider" variant="middle" />
          <Grid container>
            <Grid item xs={4}>
              <Typography variant="h5" component="h5" align="center">
                {i18n.t('dashboard:fulltime')}
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                component="h6"
                align="center"
              >
                {formatMoney(fullTimeCost)}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h5" component="h5" align="center">
                {i18n.t('dashboard:freelancer')}
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                component="h6"
                align="center"
              >
                {formatMoney(freelancerCost)}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h5" component="h5" align="center">
                {i18n.t('dashboard:contractor')}
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                component="h6"
                align="center"
              >
                {formatMoney(contractorCost)}
              </Typography>
            </Grid>
          </Grid>
          {discrepancy.length > 0 && this.renderDiscrepancy()}
        </CardContent>
      </Card>
    );
  }
}

PlannedCost.propTypes = {
  fullTimeCost: PropTypes.number.isRequired,
  freelancerCost: PropTypes.number.isRequired,
  contractorCost: PropTypes.number.isRequired,
  discrepancy: PropTypes.arrayOf(PropTypes.shape({
    studioEmployeeId: PropTypes.number,
    positionId: PropTypes.number,
    availabilityType: PropTypes.string,
    date: PropTypes.string,
  })).isRequired,
};

export default PlannedCost;
